import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import FlowsPostHeader from '../../molecules/FlowsPostHeader';
import FeedPostReactions from '../FeedPostReactions';
import FlowPostBody from '../FlowPostBody';

import Collapse from '@material-ui/core/Collapse';
import pickBy from 'lodash/pickBy';
import { useLocation } from 'react-router';
import { ComponentStatus } from '../../../interfaces/component';
import { POST_ANALYTICS_EVENTS } from '../../../Utils/analytics/constants';
import { trackPostActionEvent } from '../../../Utils/analytics/post';
import Body from '../../atoms/Body';
import { FlowAccordionItemState } from '../../molecules/FlowAccordionItem/interface';
import {
  AccordionItemBody,
  StyledArrowIcon,
} from '../../molecules/FlowAccordionItem/styles';
import FlowRepliesBar from '../FlowRepliesBar';
import {
  SamplePostWrapper,
  FlowFeedPostWrapper,
  FlowRepliesBarWrapper,
  StyledAccordionItemHeader,
  StyledFlex,
} from './styles';
import { NewFlowFeedPostProps } from './types';
import { device } from '../../../constants/layout';
import { useMediaQuery } from 'react-responsive';

const FlowFeedPost = (props: NewFlowFeedPostProps) => {
  const history = useHistory();
  const { search } = useLocation();

  const {
    bodyProps,
    className,
    headerProps,
    profileData,
    feedItemMetaData,
    onFlowClick,
    onMemberClick,
    onReactionSet,
    onReactionUnSet,
    reactionBarProps,
    dropdownComponent,
    isAnonymous,
    hideInteractions,
    repliesBarProps,
    hideRepliesBar,
    hideBorder,
    variant,
    isSamplePost,
  } = props;

  const params = new URLSearchParams(search).entries();
  const queryParameters = Object.fromEntries(params);

  const isMobileView = useMediaQuery({
    query: device.mobile,
  });

  const handleOnRepliesClick = useCallback(() => {
    history.replace({
      search: new URLSearchParams({
        ...queryParameters,
        ...pickBy(feedItemMetaData, (value) => value),
        showReplies: 'true',
      }).toString(),
    });

    trackPostActionEvent({
      ...feedItemMetaData,
      messageType: 'replies',
      flowName: headerProps.flow.name,
      action: POST_ANALYTICS_EVENTS.VIEW_REPLIES_CLICKED,
    });
  }, [history, queryParameters, feedItemMetaData, headerProps.flow.name]);

  const [isExpanded, setIsExpanded] = React.useState(
    isMobileView || queryParameters.showOriginalPost === 'true',
  );

  const renderPostContent = () => {
    return (
      <>
        <FlowPostBody
          {...bodyProps}
          {...feedItemMetaData}
          variant={variant}
          flow={headerProps.flow}
          isAnonymous={isAnonymous}
          person={headerProps.person}
          onMemberClick={onMemberClick}
          createdAt={headerProps.createdAt}
          visibility={headerProps.visibility}
        />
        <div>
          <FeedPostReactions
            {...reactionBarProps}
            variant={variant}
            hideBorder={hideBorder}
            onEmoticonSelect={onReactionSet}
            feedItemMetaData={feedItemMetaData}
            onReactionToggleClick={onReactionUnSet}
            hideInteractions={hideInteractions}
            currentUserId={profileData.member.memberId}
          />
          {!hideRepliesBar &&
            (feedItemMetaData.flowId ||
              feedItemMetaData.postId ||
              feedItemMetaData.responseId) &&
            repliesBarProps.status === ComponentStatus.LOADED && (
              <FlowRepliesBarWrapper
                data-test-id={`replies-bar`}
                data-qa-id={`btn-post-reply`}
                onClick={handleOnRepliesClick}
              >
                <FlowRepliesBar {...repliesBarProps} />
              </FlowRepliesBarWrapper>
            )}
        </div>
      </>
    );
  };

  return (
    <FlowFeedPostWrapper
      className={className}
      hideBorder={hideBorder}
      data-testid="flow-feed-post"
      data-qa-id="flow-feed-post"
      data-js-id="flow-feed-post" // required for post width calculation
    >
      {isSamplePost && (
        <SamplePostWrapper>
          <Body variant="body2" color="gray9">
            This is a sample post - it is only visible to you
          </Body>
        </SamplePostWrapper>
      )}
      {variant !== 'sidebar' && (
        <FlowsPostHeader
          {...headerProps}
          variant={variant}
          onFlowClick={onFlowClick}
          onClickUserName={onMemberClick}
          currentUserId={profileData.member.memberId}
          dropdownComponent={hideInteractions ? undefined : dropdownComponent}
        />
      )}
      {variant === 'sidebar' ? (
        <>
          <StyledAccordionItemHeader
            type="button"
            hideBorder={true}
            isOpen={isExpanded}
            state={FlowAccordionItemState.Focus}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <StyledFlex>
              <Body variant="body2" color="gray8">
                {isExpanded ? 'Hide original post' : 'Show original post'}
              </Body>
              <StyledArrowIcon
                size="18px"
                icon="caret-rounded"
                rotate={isExpanded ? 0 : 180}
                state={FlowAccordionItemState.Focus}
                data-testid="accordionItemCaratIcon"
              />
            </StyledFlex>
          </StyledAccordionItemHeader>
          <AccordionItemBody>
            <Collapse in={isExpanded}>{renderPostContent()}</Collapse>
          </AccordionItemBody>
        </>
      ) : (
        renderPostContent()
      )}
    </FlowFeedPostWrapper>
  );
};

export default FlowFeedPost;
